
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const steps = [
  {
    number: '01',
    icon: 'ri-search-eye-line',
    title: 'Auditoría de Software',
    description: 'Relevamos todo el software instalado en tu empresa para identificar licencias faltantes, vencidas o irregulares.',
  },
  {
    number: '02',
    icon: 'ri-file-list-3-line',
    title: 'Presupuesto Detallado',
    description: 'Elaboramos un presupuesto personalizado con las mejores opciones de licenciamiento según tus necesidades y presupuesto.',
  },
  {
    number: '03',
    icon: 'ri-install-line',
    title: 'Instalación & Activación',
    description: 'Instalamos y activamos todas las licencias en tus equipos, asegurando la correcta configuración y funcionamiento.',
  },
  {
    number: '04',
    icon: 'ri-shield-star-line',
    title: 'Soporte Continuo',
    description: 'Te acompañamos con soporte técnico post-venta, actualizaciones y renovaciones para mantener todo al día.',
  },
];

export function LicenseProcess() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-20 bg-gray-950 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,255,240,0.03),transparent_60%)]"></div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={ref} className={`text-center mb-14 anim-fade-up ${isVisible ? 'visible' : ''}`}>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            ¿Cómo <strong className="text-neon-400 text-neon-glow-sm">Trabajamos</strong>?
          </h2>
          <p className="text-base text-gray-400 max-w-2xl mx-auto">
            Un proceso simple y transparente para regularizar el software de tu empresa
          </p>
          <div className="neon-line max-w-xs mx-auto mt-6 opacity-40"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-gray-900/60 rounded-xl p-6 border border-gray-800 hover:border-rosa-400/30 transition-all duration-300 group hover-lift"
            >
              <div className="absolute -top-3 -right-3 w-10 h-10 flex items-center justify-center bg-rosa-400/20 border border-rosa-400/30 rounded-lg text-rosa-400 text-xs font-bold">
                {step.number}
              </div>
              <div className="w-12 h-12 flex items-center justify-center bg-rosa-400/10 border border-rosa-400/20 rounded-lg mb-5 group-hover:bg-rosa-400/20 transition-all duration-300">
                <i className={`${step.icon} text-2xl text-rosa-400`}></i>
              </div>
              <h3 className="text-base font-bold text-white mb-2"><strong>{step.title}</strong></h3>
              <p className="text-xs text-gray-400 leading-relaxed">{step.description}</p>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2">
                  <i className="ri-arrow-right-s-line text-gray-700 text-lg"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
